module.exports = __webpack_public_path__ + "static/media/copy.450db944.svg";